import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { ContainerInformationProjectDetails } from "../../../../components/container/ContainerInformationProjectDetails";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import CardProjectFiche from "./CardProjectFiche";


const areaMappings = {
    web: "Programación Web",
    unity: "Programación Unity",
    art3d: "Arte 3D",
    design: "Diseño UI/UX",
    comercial: "Comercial",
    responsible: "Responsable",
    leader: "Líder",
};

const orderedAreas = ["design", "art3d", "unity", "web", "comercial", "responsible", "leader"];

const CardTeam = ({ isSuperAdmin, isAdmin, team, activeModalDetailsProject }) => {
    const { values } = team;

    if (!team) return <></>;
    if (team.length === 0) return <></>;

    return (
        <CardProjectFiche
            title="Equipo"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.workTeam);
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="h-[240px] xl:h-[320px] overflow-auto">
                {orderedAreas.map((area, index) => {
                    const value = values[area];

                    return (
                        <ContainerInformationProjectDetails key={`${index}-team-view`} className="h-[48px]" name={areaMappings[area]}>
                            <div className="bg-[#EFF2F5] rounded-[4px] pl-2 py-2 w-full h-full flex flex-col lg:flex-row gap-2 overflow-y-auto">
                                {value.length === 0 ? (
                                    <></>
                                ) : (
                                    value.map((iteam, index, arr) => {
                                        return (
                                            <div key={`${index}-leader-team`} className=" h-full flex items-center">
                                                <span className="text-[10px] ">
                                                    {iteam.name} {arr.length !== index + 1 && ","}
                                                </span>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                        </ContainerInformationProjectDetails>
                    );
                })}
            </div>
        </CardProjectFiche>
    );
};

export default CardTeam;
